import { property, CollisionComponent} from '@wonderlandengine/api';
import { EToy } from './etoy.js';
import { EventsClient } from '../events-client.js';
import { IntifaceController, SupportedAction } from '../IntifaceController.js';
import Logger from '../utils/logger.js';

const MODULE = 'Prosthetic';

/**
 * prosthetic
 */
export class Prosthetic extends EToy {
    static TypeName = 'prosthetic';

    /* Properties that are configurable in the editor */

    @property.float(0.0)    
    defaultEffectIntensity: number = 0.1;
    @property.float(1.0)
    activeEffectIntensity: number = 1.0;
    @property.int(10)
    updatesPerSecond: number = 10.0;
    @property.float(500)
    sustainMs: number = 500.0;
    @property.int(7)
    ignoreGroup: number = 7;

    private _accumulator = 0;
    /** Collision component of this object. @hidden */
    private _collision: CollisionComponent = null!;

    start() {
        this._collision = this.object.getComponent('collision', 0)!;
        if (!this._collision) {
            throw new Error('prosthetic.start(): No collision component found');
        }
    }

    update(dt: number) {
        this._accumulator += dt;
        const interval = 1 / Math.max(1, this.updatesPerSecond);
        if (this._accumulator < interval) return;
        this._accumulator = 0;

        const player = EventsClient.instance?.activePlayerObject;
        if (!player) {
            Logger.warn('[Prosthetic] No playerObject; skipping', MODULE);
            return;
        }

        let magnitude = this.defaultEffectIntensity;
        if (this.active && this.checkForNearbyInteractables()) {
            magnitude = this.activeEffectIntensity;
        }

        IntifaceController.instance.hapticEnvironment.registerInfluence(this.object, SupportedAction.Vibrate, [magnitude, magnitude], this.sustainMs);
    }

    /**
     * Check for nearby interactable, and notifies one if this interactor
     * interacts with it.
     */
    public checkForNearbyInteractables() : boolean {
        const overlaps = this._collision.queryOverlaps();
        for (const overlap of overlaps) {
            if (!((overlap.group & (1 << this.ignoreGroup)) != 0)) {
                return true;
            }
        }
        
        return false;
    }
}
